import { useCallback } from 'react'

import { useRegionAdventuresQuery } from 'hooks/useQueries'

import { InsetContainer } from '../../../../components/layout/Container'
import SuggestedAdventures from '../../../adventure/SuggestedAdventures'
import { HeadingXl } from '../../../../components/display/Typography'

type RegionAdventureProps = {
  regionId: string
}

const RegionAdventures = ({ regionId }: RegionAdventureProps) => {
  const { data, loading, fetchMore } = useRegionAdventuresQuery({
    variables: {
      regionId,
    },
  })

  const adventures = data?.region?.adventures

  const pageInfo = data?.region?.adventures?.pageInfo

  const endCursor = pageInfo?.endCursor
  const hasNextPage = pageInfo?.hasNextPage

  const noAdventures = !adventures || adventures?.edges?.length === 0

  const isEmpty = !loading && noAdventures

  const handleFetchMore = useCallback(() => {
    fetchMore({
      variables: {
        cursor: endCursor,
      },
    })
  }, [fetchMore, pageInfo])

  return (
    <InsetContainer>
      <SuggestedAdventures
        adventures={adventures}
        inItineraryContext={false}
        canFetchMore={hasNextPage}
        loading={loading}
        isEmpty={isEmpty}
        handleFetchMore={handleFetchMore}
        maxSlidesDesktop={4}
        customTitle={<HeadingXl>Things to do in this area</HeadingXl>}
      />
    </InsetContainer>
  )
}

export default RegionAdventures
